// The init function is called on both the server and browser
// before rendering
function init(model) {
}